import { gql } from '@apollo/client';

export const FETCH_BATCHES = gql`
  subscription batchDocumentStats($filter: BatchStatusRequestDTO) {
    batchDocumentStats(batchStatusRequestDTO: $filter) {
      statusCode
      status
      page
      id
      dataCount
      data {
        id
        batchName
        batchType
        channelType
        splitType
        envelopeType
        scheduledTime
        approvalType
        approver
        triggeredBy
        totalCount
        initiatedFrom
        status
        createdTime
        requiresApproval
        batchEnd
        processingComplete
        approvalCompleted
        printQueueCount
        printCompleteCount
        printInitiated
        languageStats
        stationaryName
        insertName
        deliveryClass
        batchStats {
          id
          channel
          inQueueCount
          successCount
          failureCount
          totalCount
          batchNumber
          status
          createdOn
          unknownCount
        }
      }
    }
  }
`;

export const FETCH_BATCH_AUDIT = gql`
  subscription batchAudit($batchId: Int) {
    batchAudit(batchId: $batchId) {
      batchAuditList {
        createdBy
        event
        status
        createdOn
        statusMessage
        email
      }
    }
  }
`;